function cov_ehh839z3q() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Modal/shared.tsx";
  var hash = "4f7b43aab368772fbe93b7b215ea3183981dcbf0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Modal/shared.tsx",
    statementMap: {
      "0": {
        start: {
          line: 33,
          column: 37
        },
        end: {
          line: 79,
          column: 1
        }
      },
      "1": {
        start: {
          line: 34,
          column: 23
        },
        end: {
          line: 34,
          column: 34
        }
      },
      "2": {
        start: {
          line: 35,
          column: 66
        },
        end: {
          line: 35,
          column: 81
        }
      },
      "3": {
        start: {
          line: 41,
          column: 27
        },
        end: {
          line: 52,
          column: 16
        }
      },
      "4": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 51,
          column: 5
        }
      },
      "5": {
        start: {
          line: 43,
          column: 22
        },
        end: {
          line: 43,
          column: 45
        }
      },
      "6": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 40
        }
      },
      "7": {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 45,
          column: 35
        }
      },
      "8": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 56
        }
      },
      "9": {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 47,
          column: 41
        }
      },
      "10": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 40
        }
      },
      "11": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 50,
          column: 41
        }
      },
      "12": {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 78,
          column: 69
        }
      },
      "13": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 60,
          column: 5
        }
      },
      "14": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 59,
          column: 13
        }
      },
      "15": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 74,
          column: 5
        }
      },
      "16": {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 71,
          column: 7
        }
      },
      "17": {
        start: {
          line: 64,
          column: 20
        },
        end: {
          line: 64,
          column: 34
        }
      },
      "18": {
        start: {
          line: 65,
          column: 8
        },
        end: {
          line: 65,
          column: 47
        }
      },
      "19": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 46
        }
      },
      "20": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 42
        }
      },
      "21": {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 48
        }
      },
      "22": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 42
        }
      },
      "23": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 73,
          column: 25
        }
      },
      "24": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 77,
          column: 28
        }
      },
      "25": {
        start: {
          line: 119,
          column: 55
        },
        end: {
          line: 169,
          column: 1
        }
      },
      "26": {
        start: {
          line: 130,
          column: 2
        },
        end: {
          line: 168,
          column: 5
        }
      },
      "27": {
        start: {
          line: 171,
          column: 55
        },
        end: {
          line: 217,
          column: 1
        }
      },
      "28": {
        start: {
          line: 177,
          column: 2
        },
        end: {
          line: 216,
          column: 8
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 33,
            column: 37
          },
          end: {
            line: 33,
            column: 38
          }
        },
        loc: {
          start: {
            line: 33,
            column: 58
          },
          end: {
            line: 79,
            column: 1
          }
        },
        line: 33
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 41,
            column: 39
          },
          end: {
            line: 41,
            column: 40
          }
        },
        loc: {
          start: {
            line: 41,
            column: 45
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 41
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 53,
            column: 12
          },
          end: {
            line: 53,
            column: 13
          }
        },
        loc: {
          start: {
            line: 53,
            column: 18
          },
          end: {
            line: 78,
            column: 3
          }
        },
        line: 53
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 119,
            column: 55
          },
          end: {
            line: 119,
            column: 56
          }
        },
        loc: {
          start: {
            line: 130,
            column: 2
          },
          end: {
            line: 168,
            column: 5
          }
        },
        line: 130
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 171,
            column: 55
          },
          end: {
            line: 171,
            column: 56
          }
        },
        loc: {
          start: {
            line: 177,
            column: 2
          },
          end: {
            line: 216,
            column: 8
          }
        },
        line: 177
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        }, {
          start: {
            line: 48,
            column: 11
          },
          end: {
            line: 51,
            column: 5
          }
        }],
        line: 42
      },
      "1": {
        loc: {
          start: {
            line: 46,
            column: 34
          },
          end: {
            line: 46,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 34
          },
          end: {
            line: 46,
            column: 41
          }
        }, {
          start: {
            line: 46,
            column: 45
          },
          end: {
            line: 46,
            column: 48
          }
        }],
        line: 46
      },
      "2": {
        loc: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 60,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 60,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 56
      },
      "3": {
        loc: {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 56,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 56,
            column: 15
          }
        }, {
          start: {
            line: 56,
            column: 19
          },
          end: {
            line: 56,
            column: 44
          }
        }],
        line: 56
      },
      "4": {
        loc: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        }, {
          start: {
            line: 72,
            column: 11
          },
          end: {
            line: 74,
            column: 5
          }
        }],
        line: 62
      },
      "5": {
        loc: {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        }, {
          start: {
            line: 68,
            column: 13
          },
          end: {
            line: 71,
            column: 7
          }
        }],
        line: 63
      },
      "6": {
        loc: {
          start: {
            line: 127,
            column: 2
          },
          end: {
            line: 127,
            column: 20
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 127,
            column: 16
          },
          end: {
            line: 127,
            column: 20
          }
        }],
        line: 127
      },
      "7": {
        loc: {
          start: {
            line: 128,
            column: 2
          },
          end: {
            line: 128,
            column: 34
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 128,
            column: 28
          },
          end: {
            line: 128,
            column: 34
          }
        }],
        line: 128
      },
      "8": {
        loc: {
          start: {
            line: 132,
            column: 21
          },
          end: {
            line: 132,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 132,
            column: 42
          },
          end: {
            line: 132,
            column: 55
          }
        }, {
          start: {
            line: 132,
            column: 58
          },
          end: {
            line: 132,
            column: 67
          }
        }],
        line: 132
      },
      "9": {
        loc: {
          start: {
            line: 133,
            column: 23
          },
          end: {
            line: 133,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 133,
            column: 44
          },
          end: {
            line: 133,
            column: 45
          }
        }, {
          start: {
            line: 133,
            column: 48
          },
          end: {
            line: 133,
            column: 57
          }
        }],
        line: 133
      },
      "10": {
        loc: {
          start: {
            line: 138,
            column: 10
          },
          end: {
            line: 148,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 138,
            column: 25
          },
          end: {
            line: 138,
            column: 29
          }
        }, {
          start: {
            line: 139,
            column: 12
          },
          end: {
            line: 147,
            column: 21
          }
        }],
        line: 138
      },
      "11": {
        loc: {
          start: {
            line: 167,
            column: 5
          },
          end: {
            line: 167,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 167,
            column: 5
          },
          end: {
            line: 167,
            column: 16
          }
        }, {
          start: {
            line: 167,
            column: 20
          },
          end: {
            line: 167,
            column: 31
          }
        }],
        line: 167
      },
      "12": {
        loc: {
          start: {
            line: 181,
            column: 19
          },
          end: {
            line: 181,
            column: 47
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 181,
            column: 31
          },
          end: {
            line: 181,
            column: 39
          }
        }, {
          start: {
            line: 181,
            column: 42
          },
          end: {
            line: 181,
            column: 47
          }
        }],
        line: 181
      },
      "13": {
        loc: {
          start: {
            line: 182,
            column: 20
          },
          end: {
            line: 182,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 182,
            column: 32
          },
          end: {
            line: 182,
            column: 41
          }
        }, {
          start: {
            line: 182,
            column: 44
          },
          end: {
            line: 182,
            column: 59
          }
        }],
        line: 182
      },
      "14": {
        loc: {
          start: {
            line: 184,
            column: 5
          },
          end: {
            line: 200,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 184,
            column: 5
          },
          end: {
            line: 184,
            column: 23
          }
        }, {
          start: {
            line: 185,
            column: 6
          },
          end: {
            line: 199,
            column: 8
          }
        }],
        line: 184
      },
      "15": {
        loc: {
          start: {
            line: 187,
            column: 15
          },
          end: {
            line: 187,
            column: 32
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 187,
            column: 27
          },
          end: {
            line: 187,
            column: 28
          }
        }, {
          start: {
            line: 187,
            column: 31
          },
          end: {
            line: 187,
            column: 32
          }
        }],
        line: 187
      },
      "16": {
        loc: {
          start: {
            line: 189,
            column: 15
          },
          end: {
            line: 189,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 189,
            column: 52
          },
          end: {
            line: 189,
            column: 58
          }
        }, {
          start: {
            line: 189,
            column: 61
          },
          end: {
            line: 189,
            column: 67
          }
        }],
        line: 189
      },
      "17": {
        loc: {
          start: {
            line: 189,
            column: 15
          },
          end: {
            line: 189,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 189,
            column: 15
          },
          end: {
            line: 189,
            column: 24
          }
        }, {
          start: {
            line: 189,
            column: 28
          },
          end: {
            line: 189,
            column: 49
          }
        }],
        line: 189
      },
      "18": {
        loc: {
          start: {
            line: 190,
            column: 12
          },
          end: {
            line: 190,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 190,
            column: 50
          },
          end: {
            line: 190,
            column: 53
          }
        }, {
          start: {
            line: 190,
            column: 56
          },
          end: {
            line: 190,
            column: 65
          }
        }],
        line: 190
      },
      "19": {
        loc: {
          start: {
            line: 190,
            column: 12
          },
          end: {
            line: 190,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 190,
            column: 12
          },
          end: {
            line: 190,
            column: 21
          }
        }, {
          start: {
            line: 190,
            column: 25
          },
          end: {
            line: 190,
            column: 47
          }
        }],
        line: 190
      },
      "20": {
        loc: {
          start: {
            line: 191,
            column: 20
          },
          end: {
            line: 191,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 191,
            column: 59
          },
          end: {
            line: 191,
            column: 62
          }
        }, {
          start: {
            line: 191,
            column: 65
          },
          end: {
            line: 191,
            column: 74
          }
        }],
        line: 191
      },
      "21": {
        loc: {
          start: {
            line: 191,
            column: 20
          },
          end: {
            line: 191,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 191,
            column: 20
          },
          end: {
            line: 191,
            column: 30
          }
        }, {
          start: {
            line: 191,
            column: 34
          },
          end: {
            line: 191,
            column: 56
          }
        }],
        line: 191
      },
      "22": {
        loc: {
          start: {
            line: 201,
            column: 5
          },
          end: {
            line: 215,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 201,
            column: 5
          },
          end: {
            line: 201,
            column: 25
          }
        }, {
          start: {
            line: 202,
            column: 6
          },
          end: {
            line: 214,
            column: 8
          }
        }],
        line: 201
      },
      "23": {
        loc: {
          start: {
            line: 203,
            column: 17
          },
          end: {
            line: 203,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 203,
            column: 53
          },
          end: {
            line: 203,
            column: 64
          }
        }, {
          start: {
            line: 203,
            column: 67
          },
          end: {
            line: 203,
            column: 90
          }
        }],
        line: 203
      },
      "24": {
        loc: {
          start: {
            line: 203,
            column: 17
          },
          end: {
            line: 203,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 203,
            column: 17
          },
          end: {
            line: 203,
            column: 26
          }
        }, {
          start: {
            line: 203,
            column: 30
          },
          end: {
            line: 203,
            column: 50
          }
        }],
        line: 203
      },
      "25": {
        loc: {
          start: {
            line: 204,
            column: 15
          },
          end: {
            line: 204,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 204,
            column: 50
          },
          end: {
            line: 204,
            column: 56
          }
        }, {
          start: {
            line: 204,
            column: 59
          },
          end: {
            line: 204,
            column: 65
          }
        }],
        line: 204
      },
      "26": {
        loc: {
          start: {
            line: 204,
            column: 15
          },
          end: {
            line: 204,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 204,
            column: 15
          },
          end: {
            line: 204,
            column: 24
          }
        }, {
          start: {
            line: 204,
            column: 28
          },
          end: {
            line: 204,
            column: 47
          }
        }],
        line: 204
      },
      "27": {
        loc: {
          start: {
            line: 205,
            column: 20
          },
          end: {
            line: 205,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 205,
            column: 56
          },
          end: {
            line: 205,
            column: 66
          }
        }, {
          start: {
            line: 205,
            column: 69
          },
          end: {
            line: 205,
            column: 78
          }
        }],
        line: 205
      },
      "28": {
        loc: {
          start: {
            line: 205,
            column: 20
          },
          end: {
            line: 205,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 205,
            column: 20
          },
          end: {
            line: 205,
            column: 30
          }
        }, {
          start: {
            line: 205,
            column: 34
          },
          end: {
            line: 205,
            column: 53
          }
        }],
        line: 205
      },
      "29": {
        loc: {
          start: {
            line: 206,
            column: 19
          },
          end: {
            line: 206,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 206,
            column: 41
          },
          end: {
            line: 206,
            column: 49
          }
        }, {
          start: {
            line: 206,
            column: 52
          },
          end: {
            line: 206,
            column: 61
          }
        }],
        line: 206
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0],
      "7": [0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4f7b43aab368772fbe93b7b215ea3183981dcbf0"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ehh839z3q = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_ehh839z3q();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, Divider, Icon } from '../../core';
import { useDevice } from '../../hooks/useMedia';
import { NavigationBar } from './NavigationBar';
cov_ehh839z3q().s[0]++;

/**
 * Helper hook to remove scrolling to the parent element when modal is opened.
 */
export var useDisabledBodyScroll = function useDisabledBodyScroll(isOpen) {
  cov_ehh839z3q().f[0]++;

  var _ref = (cov_ehh839z3q().s[1]++, useDevice()),
      isMobile = _ref.isMobile;

  var _ref2 = (cov_ehh839z3q().s[2]++, useState(false)),
      _ref3 = _slicedToArray(_ref2, 2),
      isScrollingBodyPrevented = _ref3[0],
      setIsScrollingBodyPrevented = _ref3[1];
  /*
      Scrolling needs to be blocked on elements behind the modal for a better accessable design.
      The useEffect below blocks scrolling when modal is opened.
      https://chakra-ui.com/docs/overlay/modal#keyboard-and-focus-management
  */


  var handleModalClose = (cov_ehh839z3q().s[3]++, useCallback(function () {
    cov_ehh839z3q().f[1]++;
    cov_ehh839z3q().s[4]++;

    if (isMobile) {
      cov_ehh839z3q().b[0][0]++;
      var scrollY = (cov_ehh839z3q().s[5]++, document.body.style.top);
      cov_ehh839z3q().s[6]++;
      document.body.style.position = '';
      cov_ehh839z3q().s[7]++;
      document.body.style.top = '';
      cov_ehh839z3q().s[8]++;
      window.scrollTo(0, parseInt((cov_ehh839z3q().b[1][0]++, scrollY) || (cov_ehh839z3q().b[1][1]++, '0')) * -1);
      cov_ehh839z3q().s[9]++;
      setIsScrollingBodyPrevented(false);
    } else {
      cov_ehh839z3q().b[0][1]++;
      cov_ehh839z3q().s[10]++;
      document.body.style.overflow = '';
      cov_ehh839z3q().s[11]++;
      setIsScrollingBodyPrevented(false);
    }
  }, [isMobile]));
  cov_ehh839z3q().s[12]++;
  useEffect(function () {
    cov_ehh839z3q().f[2]++;
    cov_ehh839z3q().s[13]++;

    // Need specific styling for iOS body touchscreen
    // https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
    if ((cov_ehh839z3q().b[3][0]++, !isOpen) && (cov_ehh839z3q().b[3][1]++, !isScrollingBodyPrevented)) {
      cov_ehh839z3q().b[2][0]++;
      cov_ehh839z3q().s[14]++;
      // does not run rest of code in the useEffect since modal has not been opened & is not in the process of being opened
      // this is needed for pages that have multiple modals on the page
      return;
    } else {
      cov_ehh839z3q().b[2][1]++;
    }

    cov_ehh839z3q().s[15]++;

    if (isOpen) {
      cov_ehh839z3q().b[4][0]++;
      cov_ehh839z3q().s[16]++;

      if (isMobile) {
        cov_ehh839z3q().b[5][0]++;
        var top = (cov_ehh839z3q().s[17]++, window.scrollY);
        cov_ehh839z3q().s[18]++;
        document.body.style.position = 'fixed';
        cov_ehh839z3q().s[19]++;
        document.body.style.top = "-".concat(top, "px");
        cov_ehh839z3q().s[20]++;
        setIsScrollingBodyPrevented(true);
      } else {
        cov_ehh839z3q().b[5][1]++;
        cov_ehh839z3q().s[21]++;
        document.body.style.overflow = 'hidden';
        cov_ehh839z3q().s[22]++;
        setIsScrollingBodyPrevented(true);
      }
    } else {
      cov_ehh839z3q().b[4][1]++;
      cov_ehh839z3q().s[23]++;
      handleModalClose();
    } // Ensure that we re-enable scrolling if the component is unmounted


    cov_ehh839z3q().s[24]++;
    return handleModalClose;
  }, [isMobile, isOpen, isScrollingBodyPrevented, handleModalClose]);
};
cov_ehh839z3q().s[25]++;
export var ModalHeader = function ModalHeader(_ref4) {
  var trackBoxImpression = _ref4.trackBoxImpression,
      analyticsName = _ref4.analyticsName,
      onBackClick = _ref4.onBackClick,
      onRequestClose = _ref4.onRequestClose,
      title = _ref4.title,
      subtitle = _ref4.subtitle,
      id = _ref4.id,
      _ref4$showDivider = _ref4.showDivider,
      showDivider = _ref4$showDivider === void 0 ? (cov_ehh839z3q().b[6][0]++, true) : _ref4$showDivider,
      _ref4$headerIconButto = _ref4.headerIconButtonVariant,
      headerIconButtonVariant = _ref4$headerIconButto === void 0 ? (cov_ehh839z3q().b[7][0]++, 'icon') : _ref4$headerIconButto;
  cov_ehh839z3q().f[3]++;
  cov_ehh839z3q().s[26]++;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    analyticsName: trackBoxImpression ? (cov_ehh839z3q().b[8][0]++, analyticsName) : (cov_ehh839z3q().b[8][1]++, undefined),
    inViewThreshold: trackBoxImpression ? (cov_ehh839z3q().b[9][0]++, 0) : (cov_ehh839z3q().b[9][1]++, undefined),
    flexGrow: 0
  }, /*#__PURE__*/React.createElement(NavigationBar, {
    leftComponent: !onBackClick ? (cov_ehh839z3q().b[10][0]++, null) : (cov_ehh839z3q().b[10][1]++, /*#__PURE__*/React.createElement(Button, {
      id: "modal-back-button",
      onClick: onBackClick,
      variant: headerIconButtonVariant,
      analyticsName: "".concat(analyticsName, "-back"),
      "aria-label": "Back"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "chevron-left",
      size: 16,
      "aria-hidden": "true"
    }))),
    rightComponent: /*#__PURE__*/React.createElement(Button, {
      id: "modal-close-button",
      onClick: onRequestClose,
      variant: headerIconButtonVariant,
      analyticsName: "".concat(analyticsName, "-close"),
      "aria-label": "Close",
      zIndex: 1
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "close",
      size: 16,
      "aria-hidden": "true"
    })),
    title: title,
    subtitle: subtitle,
    id: id
  })), (cov_ehh839z3q().b[11][0]++, showDivider) && (cov_ehh839z3q().b[11][1]++, /*#__PURE__*/React.createElement(Divider, null)));
};
cov_ehh839z3q().s[27]++;
export var ModalFooter = function ModalFooter(_ref5) {
  var stackCTAs = _ref5.stackCTAs,
      primaryButtonProps = _ref5.primaryButtonProps,
      secondaryButtonProps = _ref5.secondaryButtonProps,
      analyticsName = _ref5.analyticsName;
  cov_ehh839z3q().f[4]++;
  cov_ehh839z3q().s[28]++;
  return /*#__PURE__*/React.createElement(Box, {
    py: "6",
    px: "7",
    display: "flex",
    flexDirection: stackCTAs ? (cov_ehh839z3q().b[12][0]++, 'column') : (cov_ehh839z3q().b[12][1]++, 'row'),
    justifyContent: stackCTAs ? (cov_ehh839z3q().b[13][0]++, undefined) : (cov_ehh839z3q().b[13][1]++, 'space-between')
  }, (cov_ehh839z3q().b[14][0]++, primaryButtonProps) && (cov_ehh839z3q().b[14][1]++, /*#__PURE__*/React.createElement(Button, _extends({
    variant: "primary",
    order: stackCTAs ? (cov_ehh839z3q().b[15][0]++, 0) : (cov_ehh839z3q().b[15][1]++, 1),
    minWidth: "41.5%",
    width: (cov_ehh839z3q().b[17][0]++, stackCTAs) || (cov_ehh839z3q().b[17][1]++, !secondaryButtonProps) ? (cov_ehh839z3q().b[16][0]++, '100%') : (cov_ehh839z3q().b[16][1]++, 'auto'),
    mb: (cov_ehh839z3q().b[19][0]++, stackCTAs) && (cov_ehh839z3q().b[19][1]++, !!secondaryButtonProps) ? (cov_ehh839z3q().b[18][0]++, '5') : (cov_ehh839z3q().b[18][1]++, undefined),
    marginLeft: (cov_ehh839z3q().b[21][0]++, !stackCTAs) && (cov_ehh839z3q().b[21][1]++, !!secondaryButtonProps) ? (cov_ehh839z3q().b[20][0]++, '4') : (cov_ehh839z3q().b[20][1]++, undefined) // default value for aria-label
    ,
    "aria-label": null // default value for analyticsName
    ,
    analyticsName: "".concat(analyticsName, "-primary-button"),
    onClick: primaryButtonProps.onClick
  }, primaryButtonProps, {
    "data-testid": "popover-primary-button"
  }))), (cov_ehh839z3q().b[22][0]++, secondaryButtonProps) && (cov_ehh839z3q().b[22][1]++, /*#__PURE__*/React.createElement(Button, _extends({
    variant: (cov_ehh839z3q().b[24][0]++, stackCTAs) && (cov_ehh839z3q().b[24][1]++, !!primaryButtonProps) ? (cov_ehh839z3q().b[23][0]++, 'secondary') : (cov_ehh839z3q().b[23][1]++, 'inline-secondary-link'),
    width: (cov_ehh839z3q().b[26][0]++, stackCTAs) || (cov_ehh839z3q().b[26][1]++, !primaryButtonProps) ? (cov_ehh839z3q().b[25][0]++, '100%') : (cov_ehh839z3q().b[25][1]++, 'auto'),
    fontWeight: (cov_ehh839z3q().b[28][0]++, !stackCTAs) || (cov_ehh839z3q().b[28][1]++, !primaryButtonProps) ? (cov_ehh839z3q().b[27][0]++, 'semibold') : (cov_ehh839z3q().b[27][1]++, undefined),
    textAlign: !primaryButtonProps ? (cov_ehh839z3q().b[29][0]++, 'center') : (cov_ehh839z3q().b[29][1]++, undefined) // default value for aria-label
    ,
    "aria-label": null // default value for analyticsName
    ,
    analyticsName: "".concat(analyticsName, "-secondary-button"),
    onClick: secondaryButtonProps.onClick
  }, secondaryButtonProps, {
    "data-testid": "popover-secondary-button"
  }))));
};